export default __webpack_public_path__ + "static/new-york-c00384446dedd3978149eb0049e16d45.jpg";